<template>
  <div class="widget" v-if="perShift && perShift.id">
    <div class="widget-title">
      <!-- <v-icon>{{ getIconByShift(perShift.id) }}</v-icon> -->
      {{ perShift.name }}
    </div>
    <div class="widget-content">

      <div class="widget-item monthly" v-if="settings.value.show_goal">
        Daily Goal :
        <span class="value goal">
          {{ perShift[useByPaymentCapacity('daily')].goal | numFormat(currency) }}
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div
        class="widget-item current"
        v-if="settings.value.show_current_total_value"
      >
        Current Total :
        <span class="value total">
          <template v-if="target_type === 'Amount'">
            {{ perShift[useByPaymentCapacity('daily')][useNetAmount()] | numFormat(currency) }}
          </template>
          <template v-else>
            {{ perShift[useByPaymentCapacity('daily')][useNetCount] | numFormat }}
          </template>
        </span>
        <span class="word-sales" v-if="!currency">Sales</span>
      </div>

      <div 
        class="widget-item per-day" 
        v-if="settings.value.show_needed_per_hour"
      >
        Needed Per Hour :
        <span class="value needed">
          {{ neededPerHour | numFormat("$") }}
        </span>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import widgetHelper from "@/mixins/widgetHelper";
// import SendCongratulation from "@/mixins/send_congratulation";

export default {
  mixins: [widgetHelper],
  computed: {
    ...mapGetters(["streams"]),
    neededPerHour() {
      if (!(this.perShift && this.perShift[this.useByPaymentCapacity('daily')])) { return 0; }
      // if (this.perShift.daily.goal > this.perShift.daily[this.useNetAmount()]) {
      //   return (this.perShift.daily.goal - this.perShift.daily[this.useNetAmount()]) / 8;
      // }
      if (this.perShift[this.useByPaymentCapacity('daily')].goal <= 0) {
        return (this.perShift[this.useByPaymentCapacity('monthly')].goal / this.perShift[this.useByPaymentCapacity('monthly')].days.working) / 8;
      }
      return this.perShift[this.useByPaymentCapacity('daily')].goal / 8;
    },
    listeningAgents() {
      return this.perShift?.agents || [];
    },
  },
};
</script>